import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview'
import util from '../utils'
import routers from './routers'
import store from '../store'
import config from '../config'
Vue.use(Router)
const RouterConfig = {
    mode: 'hash', //history hash
    //   base: config.root,
    routes: routers
}
const router = new Router(RouterConfig)
var currentRouter = null
router.toReferrer = function() {
    if (!currentRouter) {
        router.push({ path: '/' })
    } else {
        router.push({ path: currentRouter })
    }
}
router.beforeEach((to, from, next) => {
    iView.LoadingBar.start()
    const webtitle = to.meta.title ? to.meta.title + '-' + config.siteName : config.siteName
    util.title(webtitle)
    if (to.meta.logined === false) {
        next()
    } else if (to.meta.logined === true) {
        window.currentRouter = to.path + "?id=" + to.query.id + "&key=" + to.query.key;
        if (window.routeReady) {
            next()
        }
    } else {
        if((store.state.userinfo.isUsing=='F' ||store.state.userinfo.isUsing=='N' || store.state.userinfo.isUsing=='T' )&&to.path.indexOf('settings')<0){
            router.push({ path: '/settings/basic' })
            return
        }
        if(to.path.indexOf('publish')>0){
            window.currentRouter = to.fullPath;
        }else{
            window.currentRouter = to.path;
        }
        if (to.path == "/emailsuccess") {
            window.routeReady = true;
        } else {
            window.routeReady = window.routeReady;
        }
        if (window.routeReady) {
            next()
        }
    }

})
router.afterEach(() => {
    iView.LoadingBar.finish()
    window.scrollTo(0, 0)
    var currentRoutePath = router.currentRoute.path
    store.commit('breadcrumb', currentRoutePath)
    store.commit('menu', router.currentRoute)
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js